import type React from 'react';

import classNames from 'classnames';

interface MarkFeatureCardProps {
  icon: React.ElementType;
  title: string;
  description: string;
  className?: string;
}

const MarkFeatureCard = ({
  icon,
  title,
  description,
  className,
}: MarkFeatureCardProps): React.JSX.Element => {
  const Icon = icon;

  return (
    <div
      className={classNames(
        'flex flex-1 flex-col gap-2 rounded-md bg-navy-50 px-4 pb-4 pt-3',
        className
      )}
    >
      <Icon className="size-5 text-navy-500" />
      <div className="flex flex-col gap-0.5">
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        <p className="text-sm leading-5 text-gray-700">{description}</p>
      </div>
    </div>
  );
};

export default MarkFeatureCard;
